import 'css-chunksrc/client/pages/notFoundPage/styles.scss';export default {
  "scenePlaceholder": "_scenePlaceholder_1aw5y_1"
};